import { QUOTE_TYPE } from "@/lib/constants";

export const QuoteTypeBadge = ({ type, testId }) => {
  const t = QUOTE_TYPE[type] || QUOTE_TYPE.assessment;
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${t.cls}`}>
      {t.label}
    </span>
  );
};

export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className="inline-flex items-center rounded-full bg-[#020165]/10 text-[#020165] px-2.5 py-0.5 text-[11px] font-semibold capitalize">
    {String(status || "").replace(/_/g, " ")}
  </span>
);
